import { Table } from 'components/table-compat/table-compat'
import { Container } from 'components/container/Container'
import { buildDataTableObject } from 'utils/data'
import { addHyperLinkToFirstColumn, setFirstColumnInHeaders } from './helpers'
import { useSafetyLagging } from 'hooks/safety/useSafetyLagging'
import { BasicPlaceholder } from 'components/placeholder'
import useRefresh from 'hooks/utils/useRefresh'
import useCountdown from 'hooks/utils/useCountdown'
import { ErrorAlert } from 'components/error-fallback/error-alert'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { translateTableData } from 'locales/utils'
import { useEssentials } from 'hooks/utils/useEssentials'

export const SafetyLagging = () => {
    const { t, currentLocation, pathname, env, logout, session, isEnglish } =
        useEssentials()

    let { data, isLoading, isError, refetch, remove, error } = useSafetyLagging(
        {
            env,
            accessToken: session?.accessToken ?? '',
            location: currentLocation,
        },
    )
    useRefresh(refetch, remove)
    const count = useCountdown(5, logout, error as Error)

    if (isLoading) {
        return (
            <div className="placeholder-container" data-testid="placeholder">
                <BasicPlaceholder type="table" rows={5} columns={5} />
            </div>
        )
    }

    if (isError || !data) {
        return (
            <ErrorAlert error={error} count={count} onRetry={() => refetch()} />
        )
    }

    const { safety } = TRANSLATION_KEYS
    const { nonStoreLabel, lagging } = safety
    const { title } = lagging

    let derivedData = { ...data }
    derivedData = {
        ...derivedData,
        headings: setFirstColumnInHeaders(derivedData, 'Location'),
    }
    derivedData = addHyperLinkToFirstColumn(derivedData, pathname)
    derivedData = translateTableData({
        t,
        table: derivedData,
        translation: lagging,
    })

    const columnCount = derivedData.headings?.length ?? 4
    const widths = isEnglish
        ? [50, 55, ...Array(columnCount - 2).fill(50)]
        : [65, 115, ...Array(columnCount - 2).fill(140)]

    return (
        <Container className="hc8-pa-4x">
            <p>{t(nonStoreLabel)}</p>
            <Table
                data={buildDataTableObject({
                    currentData: derivedData,
                    widths,
                    pinFirstColumn: true,
                })}
                name={t(title)}
                scrollableWidth={true}
            />
        </Container>
    )
}
